import { calculateStatus, convertUnit, type Nil, type Unit, type UserPreferredUnit } from '@core';

import type { CorridorBounds } from './types';

type UseParameterHooksArgs = {
    userPreferredUnit: UserPreferredUnit;
    unit: Unit;
    value: number | Nil;
    comparisonValue: number | Nil;
    corridorParameterMargins?: CorridorBounds | Nil;
    goalCorridorParameterMargins?: CorridorBounds | Nil;
    stdDev: number | Nil;
    mean: number | Nil;
};
export function useParameters({
    userPreferredUnit,
    unit,
    value,
    corridorParameterMargins,
    goalCorridorParameterMargins,
    comparisonValue,
    stdDev,
    mean,
}: UseParameterHooksArgs) {
    const props = convertUnit({ unit, userPreferredUnit, value });
    const corridorIndicatorColor = corridorParameterMargins
        ? calculateStatus({
              corridorParameterMargins,
              value: props.value,
          })
        : 'white';
    const goalIndicatorColor = goalCorridorParameterMargins
        ? calculateStatus({ corridorParameterMargins: goalCorridorParameterMargins, value: props.value })
        : 'white';
    const comparison = convertUnit({ unit, userPreferredUnit, value: comparisonValue });
    return {
        ...props,
        comparison: comparison.value,
        corridorParameterMargins,
        goalCorridor: goalCorridorParameterMargins,
        corridorIndicatorColor,
        goalIndicatorColor,
        mean: convertUnit({ unit, userPreferredUnit, value: mean }).value,
        stdDev: convertUnit({ unit, userPreferredUnit, value: stdDev }).value,
    };
}
